import {GET_PARTNERS_LIST} from "../action_types";

export const getPartnersList = () => {
    return {
        type: GET_PARTNERS_LIST,
        api: true
    }
};